import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { MapPin, ArrowUpRight } from "lucide-react";

const locations = [
  {
    name: "Morden",
    address: "21 London Road, SM4 5HT",
    booking: "https://www.apptio.app/book/linh-dang-nails",
  },
  {
    name: "New Malden",
    address: "175 High Street, KT3 4BH",
    booking: "https://www.apptio.app/book/angeline-nails-beauty-new-malden",
  },
  {
    name: "Worcester Park",
    address: "182 Central Road, KT4 8HQ",
    booking: "https://www.apptio.app/book/angeline-nails-beauty-wp",
  },
];

const BookingModal = ({ open, onOpenChange }) => {
  const handleBooking = (url) => {
    onOpenChange(false);
    setTimeout(() => {
      window.location.href = url;
    }, 150);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="booking-dialog sm:max-w-lg rounded-2xl border-stone-200 p-0 overflow-hidden"
        data-testid="booking-modal"
      >
        <div className="px-8 pt-8 pb-2">
          <DialogHeader>
            <DialogTitle
              className="font-heading text-2xl md:text-3xl font-medium tracking-tight text-stone-900"
              data-testid="booking-modal-title"
            >
              Select Your Branch
            </DialogTitle>
            <DialogDescription className="font-body text-stone-500 mt-1">
              Choose a location to book your appointment
            </DialogDescription>
          </DialogHeader>
        </div>

        <div className="px-8 pb-8 space-y-3" data-testid="booking-locations-list">
          {locations.map((loc) => (
            <button
              key={loc.name}
              onClick={() => handleBooking(loc.booking)}
              data-testid={`booking-location-${loc.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group w-full flex items-center justify-between p-5 rounded-xl border border-stone-200 bg-stone-50/50 hover:bg-stone-100 hover:border-stone-300 transition-all duration-300 text-left"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-stone-900 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <MapPin className="w-4 h-4 text-white" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-body font-medium text-stone-900 text-base">
                    {loc.name}
                  </p>
                  <p className="font-body text-stone-500 text-sm mt-0.5">
                    {loc.address}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-stone-400 group-hover:text-stone-900 transition-colors duration-300">
                <span className="font-body text-sm font-medium hidden sm:inline">
                  Book
                </span>
                <ArrowUpRight
                  className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  strokeWidth={1.5}
                />
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookingModal;
